export const SET_CREATE_IS_VISIBLE = 'SET_CREATE_IS_VISIBLE';
export const CREATED_CLIENT = 'CREATED_CLIENT';
export const CLIENT_UPDATE_STATUS = 'CLIENT_UPDATE_STATUS';
export const GET_CLIENTS = 'GET_CLIENTS';
export const SET_CLIENT_ID = 'SET_CLIENT_ID';
export const REMOVE_CLIENT = 'REMOVE_CLIENT';



// WEBPACK FOOTER //
// ./src/containers/AddClient/constants.js